/*
 * newsbot - forked from autobrr
 */

import { Link } from "@tanstack/react-router";
import { classNames } from "@utils";
import { NAV_ROUTES } from "./_shared";

export const LeftNav = () => (
  <div className="flex items-center">
    <div className="shrink-0 flex items-center">
      <Link to="/">
        <span className="text-xl font-bold text-gray-900 dark:text-white">newsbot</span>
      </Link>
    </div>
    <div className="sm:ml-3 hidden sm:block">
      <div className="flex items-baseline space-x-4">
        {NAV_ROUTES.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            params={{}}
          >
            {({ isActive }) => (
              <span className={
                classNames(
                  "px-3 py-2 rounded-2xl text-sm font-medium transition-colors duration-200",
                  isActive
                    ? "bg-gray-200 dark:bg-gray-800 text-black dark:text-gray-50 font-bold"
                    : "text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                )
              }>{item.name}</span>
            )}
          </Link>
        ))}
      </div>
    </div>
  </div>
);
